import { lastExecutedUIList } from "containers/rule-listing/RuleConfigurationFilters/Dropdowns/DropdownOptions";
import { stopDataDogSession } from "externals/datadog";
import moment from "moment-timezone";

import amplitude from "../../externals/amplitude";
import LocalStorage from "../../utils/LocalStorage";

export const isProdOrPreProdOrStg = () =>
  ["stg.magnifi.ai", "dbbackup.magnifi.ai", "uat.magnifi.ai", "db.magnifi.ai"].includes(window.location.hostname);

export const isProdOrPreProd = () =>
  ["dbbackup.magnifi.ai", "uat.magnifi.ai", "db.magnifi.ai"].includes(window.location.hostname);

export const isProd = () => window.location.hostname === "db.magnifi.ai";

export const isInternalUserEmail = (email) =>
  ["@magnifi.ai", "@mailinator.com"].some((domain) => email?.includes(domain));

export const magnifiSuperAdminEntityId = "org_8eb1dac0-06be-49f6-9940-05062feb822c";

export const logoutUser = (navigate) => {
  try {
    const itemsToKeep = ["otp", "email"];
    let savedItems = {};

    itemsToKeep.forEach((item) => {
      const value = LocalStorage.getItem(item);

      if (value !== null && value !== undefined && value !== "") {
        savedItems[item] = value;
      }
    });

    LocalStorage.clear();

    for (let key in savedItems) {
      LocalStorage.setItem(key, savedItems[key]);
    }

    amplitude.updateUserData(null);
    stopDataDogSession();

    if (navigate) {
      navigate("/login");
      window.location.reload();
    } else {
      window.location.href = "/login";
    }
  } catch (error) {
    console.error(error);
  }
};

export function convertISTtoUTC(start) {
  let startDateTimeUTC = moment.tz(Date.now(), "Asia/Kolkata");

  if (!start) {
    return {
      startDateTimeUTC: startDateTimeUTC.utc().format("DD/MM/YY HH:mm:ss"),
      endDateTimeUTC: startDateTimeUTC.utc().format("DD/MM/YY HH:mm:ss"),
    };
  }

  switch (start) {
    case lastExecutedUIList.fifteenMinutes:
      startDateTimeUTC.subtract(15, "minutes");
      break;
    case lastExecutedUIList.oneHour:
      startDateTimeUTC.subtract(1, "hours");
      break;
    case lastExecutedUIList.fourHours:
      startDateTimeUTC.subtract(4, "hours");
      break;
    case lastExecutedUIList.oneDay:
      startDateTimeUTC.subtract(1, "days");
      break;
    case lastExecutedUIList.twoDays:
      startDateTimeUTC.subtract(2, "days");
      break;
    case lastExecutedUIList.threeDays:
      startDateTimeUTC.subtract(3, "days");
      break;
    case lastExecutedUIList.oneWeek:
      startDateTimeUTC.subtract(1, "weeks");
      break;
    case lastExecutedUIList.fifteenDays:
      startDateTimeUTC.subtract(15, "days");
      break;
    case lastExecutedUIList.oneMonth:
      startDateTimeUTC.subtract(1, "months");
      break;
    default:
  }

  const endDateTimeUTC = moment.tz(Date.now(), "Asia/Kolkata").utc().format("DD/MM/YY HH:mm:ss");

  return {
    startDateTimeUTC: startDateTimeUTC.utc().format("DD/MM/YY HH:mm:ss"),
    endDateTimeUTC,
  };
}

export const isDatadogSynthetics = () => {
  const userAgent = navigator?.userAgent || "";

  return userAgent?.toLowerCase()?.includes("datadog");
};

export const convertTimeStringToMilliseconds = (timeString) => {
  const [hours, minutes, seconds, ms] = timeString.split(":");

  const totalMilliseconds =
    parseInt(hours, 10) * 60 * 60 * 1000 +
    parseInt(minutes, 10) * 60 * 1000 +
    parseInt(seconds, 10) * 1000 +
    parseInt(ms, 10);

  return totalMilliseconds;
};

export const isPresignedUrl = (url) => {
  try {
    const urlObj = new URL(url);
    const searchParams = urlObj.searchParams;

    // Check for required AWS S3 presigned URL parameters
    const requiredParams = [
      "X-Amz-Algorithm",
      "X-Amz-Credential",
      "X-Amz-Date",
      "X-Amz-Expires",
      "X-Amz-SignedHeaders",
      "X-Amz-Signature",
    ];

    return requiredParams.every((param) => searchParams.has(param));
  } catch (error) {
    return false;
  }
};
